import {Space} from "antd";
import {OrderListHeader} from "./header";
import {ServiceOrderList} from "./list";

export function ServiceOrders() {
  return (
    <Space size={24} direction="vertical" style={{display: "flex"}}>
      <OrderListHeader />
      <ServiceOrderList />
    </Space>
  );
}
